'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.usePagination = usePagination;

var _react = require('react');

var _reactDom = require('react-dom');

var _useDebouncedAsyncCallback = require('./useDebouncedAsyncCallback');

var _usePageMechanism2 = require('./usePageMechanism');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var FILTERED_BUFFER = Symbol('Filtered out item');
var getBufferedArray = function getBufferedArray(length) {
    return Array.from({ length: length }).fill(FILTERED_BUFFER);
};

function usePagination(_ref) {
    var _this = this;

    var loadPage = _ref.loadPage,
        loadParams = _ref.loadParams,
        pageSize = _ref.pageSize,
        maxTotalItemsBeforeThrottling = _ref.maxTotalItemsBeforeThrottling,
        _ref$estimatedTotal = _ref.estimatedTotal,
        estimatedTotal = _ref$estimatedTotal === undefined ? pageSize : _ref$estimatedTotal,
        _ref$initialState = _ref.initialState,
        initialState = _ref$initialState === undefined ? [] : _ref$initialState;

    var _usePageMechanism = (0, _usePageMechanism2.usePageMechanism)(pageSize),
        resetPageState = _usePageMechanism.resetPageState,
        markPageAsLoaded = _usePageMechanism.markPageAsLoaded,
        isPageLoaded = _usePageMechanism.isPageLoaded,
        getFilteredCountTotal = _usePageMechanism.getFilteredCountTotal,
        getPageRange = _usePageMechanism.getPageRange;

    var isMounted = (0, _react.useRef)(true);

    var _useState = (0, _react.useState)(estimatedTotal),
        _useState2 = _slicedToArray(_useState, 2),
        totalValues = _useState2[0],
        setTotalValues = _useState2[1];

    var _useState3 = (0, _react.useState)(initialState),
        _useState4 = _slicedToArray(_useState3, 2),
        values = _useState4[0],
        setValues = _useState4[1];

    var getThrottledTotals = (0, _react.useCallback)(function (totals, valuesCount) {
        if (maxTotalItemsBeforeThrottling && maxTotalItemsBeforeThrottling < totals) {
            return Math.min(totals, valuesCount + pageSize);
        }
        return totals;
    }, [maxTotalItemsBeforeThrottling, pageSize]);
    var throttledTotals = (0, _react.useMemo)(function () {
        return getThrottledTotals(totalValues, values.length);
    }, [totalValues, values.length, getThrottledTotals]);
    var fetchFrame = (0, _react.useCallback)(function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(startIndex, endIndex) {
            var params, pages, pageTuples;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            params = loadParams || {};
                            pages = getPageRange(startIndex, endIndex);
                            _context2.next = 4;
                            return Promise.all(pages.filter(function (page) {
                                return !isPageLoaded(page);
                            }).map(function () {
                                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(page) {
                                    var _ref4, _ref5, results, totals, _ref5$, filteredOut;

                                    return _regenerator2.default.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    markPageAsLoaded(page);
                                                    _context.next = 3;
                                                    return loadPage(Object.assign({
                                                        page: page,
                                                        pageSize: pageSize
                                                    }, params));

                                                case 3:
                                                    _ref4 = _context.sent;
                                                    _ref5 = _slicedToArray(_ref4, 3);
                                                    results = _ref5[0];
                                                    totals = _ref5[1];
                                                    _ref5$ = _ref5[2];
                                                    filteredOut = _ref5$ === undefined ? 0 : _ref5$;

                                                    markPageAsLoaded(page, filteredOut);
                                                    return _context.abrupt('return', [page, results, totals, filteredOut]);

                                                case 11:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, _this);
                                }));

                                return function (_x3) {
                                    return _ref3.apply(this, arguments);
                                };
                            }()));

                        case 4:
                            pageTuples = _context2.sent;
                            return _context2.abrupt('return', pageTuples);

                        case 6:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function (_x, _x2) {
            return _ref2.apply(this, arguments);
        };
    }(), [loadPage, loadParams, pageSize, getPageRange, markPageAsLoaded]);
    var loadFrame = (0, _react.useCallback)(function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee3(startIndex, endIndex) {
            var pageTuples;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return fetchFrame(startIndex, endIndex);

                        case 2:
                            pageTuples = _context3.sent;

                            if (isMounted.current) {
                                _context3.next = 5;
                                break;
                            }

                            return _context3.abrupt('return', pageTuples);

                        case 5:
                            (0, _reactDom.unstable_batchedUpdates)(function () {
                                pageTuples.forEach(function (_ref7) {
                                    var _ref8 = _slicedToArray(_ref7, 4),
                                        page = _ref8[0],
                                        results = _ref8[1],
                                        totals = _ref8[2],
                                        filteredOut = _ref8[3];

                                    if (!results || totals == null && page > 1) {
                                        return;
                                    }
                                    var filteredOutCount = getFilteredCountTotal();
                                    var absoluteTotals = totals || 0;
                                    var finalTotals = absoluteTotals - filteredOutCount;
                                    if (filteredOut) {
                                        results.push.apply(results, _toConsumableArray(getBufferedArray(filteredOut)));
                                    }
                                    setTotalValues(finalTotals);

                                    var upToIndex = (page - 1) * pageSize;
                                    setValues(function (current) {
                                        var copy = [].concat(_toConsumableArray(current));
                                        // since our values array is expanded as we go,
                                        // we have to manually set its length in order to create
                                        // a sparse array, so that results go into their proper
                                        // index
                                        copy.length = getThrottledTotals(absoluteTotals, upToIndex + results.length);
                                        return [].concat(_toConsumableArray(copy.slice(0, upToIndex)), _toConsumableArray(results), _toConsumableArray(copy.slice(upToIndex + results.length)));
                                    });
                                });
                            });
                            return _context3.abrupt('return', pageTuples);

                        case 7:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this);
        }));

        return function (_x4, _x5) {
            return _ref6.apply(this, arguments);
        };
    }(), [fetchFrame, pageSize, getFilteredCountTotal, maxTotalItemsBeforeThrottling]);
    var valuesWithoutFilteredBuffers = (0, _react.useMemo)(function () {
        return values.filter(function (v) {
            return v !== FILTERED_BUFFER;
        });
    }, [values]);
    // this function is debounced since scrolling virtual lists shouldn't
    // trigger ten requests at once
    var loadCurrentFrame = (0, _useDebouncedAsyncCallback.useDebouncedAsyncCallback)(loadFrame, 20);
    var reset = (0, _react.useCallback)(function () {
        resetPageState();
        setValues([]);
        setTotalValues(estimatedTotal);
    }, [resetPageState]);
    var reload = (0, _react.useCallback)(function () {
        reset();
        return loadFrame(0, pageSize - 1);
    }, [reset, loadFrame, pageSize]);
    var isItemLoaded = (0, _react.useCallback)(function (index) {
        return !!valuesWithoutFilteredBuffers[index];
    }, [valuesWithoutFilteredBuffers]);
    (0, _react.useEffect)(function () {
        return function () {
            isMounted.current = false;
        };
    }, []);
    return {
        values: valuesWithoutFilteredBuffers,
        loadCurrentFrame: loadCurrentFrame,
        reset: reset,
        reload: reload,
        totalValues: throttledTotals,
        isItemLoaded: isItemLoaded,
        fetchFrame: fetchFrame,
        loadFrame: loadFrame
    };
}

exports.default = usePagination;